var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.66671H3.33333V13.3334H12.6667V5.33337H10V2.66671ZM2 1.99471C2 1.62937 2.298 1.33337 2.666 1.33337H10.6667L14 4.66671V13.9954C14.0006 14.0829 13.984 14.1697 13.951 14.2509C13.9181 14.332 13.8695 14.4058 13.808 14.4682C13.7466 14.5305 13.6734 14.5801 13.5928 14.6142C13.5121 14.6482 13.4255 14.6661 13.338 14.6667H2.662C2.48692 14.6655 2.31934 14.5954 2.19548 14.4717C2.07161 14.348 2.0014 14.1805 2 14.0054V1.99471ZM7.33333 7.33337H8.66667V11.3334H7.33333V7.33337ZM7.33333 4.66671H8.66667V6.00004H7.33333V4.66671Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5f2926f4965c21b0d1e43b9a951b6168.svg";
export { ForwardRef as ReactComponent };